import { useApi } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Seo } from "@/components/site/Seo";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { StoryCard } from "@/components/site/StoryCard";

export default function Stories() {
  const { t } = useLang();
  const { data, loading } = useApi("/posts", []);
  const [first, ...rest] = data;
  return (
    <>
      <Seo title={t("stories.seoTitle")} description={t("stories.seoDesc")} />
      <PageHeader testId="stories-header" eyebrow={t("stories.eyebrow")} title={t("stories.title")}>{t("stories.intro")}</PageHeader>
      <section className="container-x pb-28" data-testid="stories-list">
        {loading && <p className="text-moss">{t("common.loading")}</p>}
        {first && (
          <Reveal className="mb-16 grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-8"><StoryCard post={first} featured /></div>
          </Reveal>
        )}
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {rest.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}><StoryCard post={p} /></Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
